import {format, isToday, isFuture, isValid} from 'date-fns';

/**
 * Add 5 Business days to a date
 * @param {Date} date
 * @return {Date}
 */
export const add5BusinessDays = (date) => {
    return addNBusinessDays(date, 5);
};
/**
 * Add n business days to a date
 * @param {!Date} date start date
 * @param {number} n number of days to add
 * @return {!Date}
 */
export const addNBusinessDays = (date, n) => {
    const getNextWorkingDay = (date) => {
        const newDate = new Date(date);
        const today = newDate.getDate();
        switch (date.getDay()) {
        // friday or saturday => next working day is monday
        // otherwise, the next working day is tomorrow
        case 5:
            newDate.setDate(today + 3);
            break;
        case 6:
            newDate.setDate(today + 2);
            break;
        default:
            newDate.setDate(today + 1);
            break;
        }
        return newDate;
    };
    let targetDate = new Date(date);
    // add n business days
    for (let i = 0; i < n; i++) {
        targetDate = getNextWorkingDay(targetDate);
    }
    return targetDate;
};
/**
 * Format a date int a string YYYY-MM-DD
 * @param {Date} date
 * @return {string}
 */
export const formatDateYYYYMMDD = (date) => {
    if (!date) {
        return '';
    }
    const mm = date.getMonth() + 1; // getMonth() is zero-based
    const dd = date.getDate();
    return [
        date.getFullYear(),
        (mm>9 ? '' : '0') + mm,
        (dd>9 ? '' : '0') + dd,
    ].join('-');
};


/**
 * We store the dates in UTC, so new Date() returns the date in current timezone
 * @param {Date | string} dateAsDateOrString
 * @return {Date}
 */
export const getDateInCurrentTimezone = (dateAsDateOrString) => {
    return dateAsDateOrString instanceof Date ? dateAsDateOrString : new Date(dateAsDateOrString);
};

/**
 * Add the current timezone to a date object
 * @param {Date} dateToUpdate
 * @return {Date}
 */
export const addCurrentTimezoneToDate = (dateToUpdate) => {
    dateToUpdate.setTime(dateToUpdate.getTime() + dateToUpdate.getTimezoneOffset() * 60 * 1000);
    return dateToUpdate;
};

/**
 * Check if a Date object is defined. If yes, check if this Date object is valid
 * @param {Date} date
 * @return {boolean} True if this date is valid, false otherwise
 */
export const isValidDate = (date) => {
    return !!date && date instanceof Date && !isNaN(date);
};

/**
 * Format the date based on the format string (eq mm/DD/YYYY)
 * @param {string} formatString
 * @return {string} formated date
 */
export const formatDate = (formatString) => {
    if (formatString) {
        try {
            return format(new Date(), formatString);
        } catch (e) {
            console.error(e);
            return 'Invalid Date Format';
        }
    }
    return 'No date format provided';
};

/**
 * Check if the date is valid
 * @param {string} dateStr
 * @return {boolean} true/false
 */
export const isDateValid = (dateStr) => {
    if (!dateStr) return false;
    return !isNaN(new Date(dateStr));
};

/**
 * Check if the format it's correct not to many m or d o y
 * @param {string} dateStr
 * @return {string} true/false
 */
export const checkDateInput = (dateStr) => {
    if (!dateStr) return '';
    let maxD = 2;
    let maxM = 2;
    let maxY = 4;
    // firsr replace all D witd, all m with M all Y with y
    const formatedStr = dateStr.replace(/D/g, 'd').replace(/m/g, 'M').replace(/Y/g, 'y');
    const splitedDateStr = formatedStr.split('');
    for (let i = 0, iMax = splitedDateStr.length; i < iMax; i++) {
        switch (splitedDateStr[i]) {
        case 'd':
            if (maxD > 0) {
                maxD = maxD-1;
            } else {
                splitedDateStr[i] = '';
            }
            break;
        case 'M':
            if (maxM > 0) {
                maxM = maxM-1;
            } else {
                splitedDateStr[i] = '';
            }
            break;
        case 'y':
            if (maxY > 0) {
                maxY = maxY-1;
            } else {
                splitedDateStr[i] = '';
            }
            break;
        }
    }
    return splitedDateStr.join('');
};

/**
 * Check if the date is today or in the future
 * @param {Date} date
 * @return {boolean} true/false
 */
export const isValidFutureDate = (date) => {
    if (!date) return false;
    let providedDate = date;
    if (Object.prototype.toString.call(date) !== '[object Date]') {
        // it means that the input is the string not the date object
        providedDate = new Date(date);
    }
    const isDateToday = isToday(providedDate);
    const isFutureDate = isFuture(providedDate);
    return isDateToday || isFutureDate;
};

/**
 *
 * @param {Array} materials
 * @return {boolean} true/false
 */
export const materialDateIsNotPastDate = (materials) => {
    let stopChecking = false;
    if (materials) {
        materials.forEach((material) =>{
            if ( !stopChecking) {
                stopChecking = !isValidFutureDate(material.requestedDeliveryDate );
            }
        });
    }
    return !stopChecking;
};

export const parseDateString = (dateStr) => {
    if (!dateStr) return null;

    const date = new Date(dateStr);

    if (isValid(date)) {
        return date;
    } else {
        return null;
    }
};
